module.exports = __webpack_public_path__ + "media/images/guideline/B02-340601225f6fd84a64bfbb2976576190.jpg";